module.exports = __webpack_public_path__ + "static/img/persion3.816579c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/persion3.png
// module id = gzl7
// module chunks = 1